import { useEffect, useState } from "react";
import { Button } from "../ui/Button";
import { fetchPlayerCostSources } from "../../lib/api";
import { rivalSource } from "../../lib/costSource";
import { Modal } from "../ui/Overlay";
import { Notice } from "../ui/Notice";
import type { RivalDef } from "../../lib/fixtures";
import { useT } from "../../lib/i18n";

/**
 * 删除竞品列前的确认（leo 2026-09-17）。竞品列的价是手填的，删了这一列，
 * 关卡制逐格价与萌宠小镇逐星价会一起没掉，保存之后没法找回——所以写明要删多少个数。
 * 有玩家单独指定了这一列时也要说：指定不跟版本走、删列不会删指定，这版发布后他们退回版本默认。
 */
export function RemoveRivalDialog({
  rival, filled, inUse, onClose, onConfirm,
}: { rival: RivalDef; filled: number; inUse: boolean; onClose: () => void; onConfirm: () => void }) {
  const t = useT();
  const [assigned, setAssigned] = useState(0);
  useEffect(() => {
    let alive = true;
    fetchPlayerCostSources().then((d) => { if (alive) setAssigned(d.rows.filter((r) => r.costSource === rivalSource(rival.id)).length); }).catch(() => { /* 拉不到就不提 */ });
    return () => { alive = false; };
  }, [rival.id]);
  return (
    <Modal
      title={t("building.removeRivalTitle", { name: rival.name })}
      width={440}
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose}>{t("common.cancel")}</Button>
          <Button tone="danger" onClick={onConfirm}>{t("building.removeRivalOk")}</Button>
        </>
      }
    >
      <div className="flex flex-col gap-3 text-sm">
        <p>{filled > 0 ? t("building.removeRivalBody", { n: filled }) : t("building.removeRivalEmpty")}</p>
        {inUse && <Notice tone="warning">{t("building.removeRivalInUse")}</Notice>}
        {assigned > 0 && <Notice tone="warning">{t("building.removeRivalAssigned", { n: assigned })}</Notice>}
      </div>
    </Modal>
  );
}
